// removed by extract-text-webpack-plugin
module.exports = {"label":"_-src-components-Filter-FilterTag-styles---label---2qkfP","value":"_-src-components-Filter-FilterTag-styles---value---1bLxv","loader":"_-src-components-Filter-FilterTag-styles---loader---37mR2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Filter/FilterTag/styles.css
// module id = 765
// module chunks = 0